/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useCallback } from 'react';
import { Text, View, StyleSheet, TextInput, TouchableOpacity } from 'react-native';
import RNPickerSelect from 'react-native-picker-select';
import { LinearGradient } from 'expo-linear-gradient';
import { doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';
import QuestionIcon from '../assets/svg/questionIcon';
import WarningIcon from '../assets/svg/warningIcon';
import Popup from '../components/Popup';
import db from '../utils/db';

const styles = StyleSheet.create({
  container: {
    marginTop: 0,
    marginLeft: 56,
    marginRight: 56,
    height: 766,
    backgroundColor: '#fff',
    marginBottom: 60,
    width: 1328,
    alignSelf: 'center',
  },
  title: {
    fontSize: 20,
    color: '#132c32',
    fontFamily: 'PingFangSC-Semibold',
  },
  titleContainer: {
    marginTop: 47,
    alignSelf: 'center',
    height: 28,
    width: 964,
  },
  warningContainer: {
    flexDirection: 'row',
    width: 540,
    marginLeft: 397,
    marginRight: 391,
    marginTop: 7,
    height: 28,
  },
  warningIcon: { marginRight: 13 },
  warningText: { fontSize: 20, color: '#132c32', fontFamily: 'PingFangSC-Semibold' },
  wireAmountContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginTop: 71,
    marginRight: 355,
    height: 37,
  },
  redeemAmountText: {
    textAlign: 'right',
    fontSize: 26,
    color: '#132c32',
    fontFamily: 'PingFangSC-Semibold',
  },
  redeemAmountInputPlaceholder: {
    paddingLeft: 16,
    fontFamily: 'PingFangSC-Regular',
    fontSize: 16,
    marginBottom: 10,
  },
  redeemAmountInput: {
    paddingLeft: 16,
    fontFamily: 'PingFangSC-Regular',
    fontSize: 23,
    marginBottom: 5,
    color: '#595959',
  },
  redeemAmountInputFrame: {
    borderBottomColor: '#555559',
    borderBottomWidth: 2,
    width: 386,
    justifyContent: 'flex-end',
  },
  redeemAmountNT: {
    fontFamily: 'PingFangSC-Regular',
    color: '#555559',
    fontSize: 26,
    marginRight: 27,
    marginLeft: 39,
  },
  feeContainer: {
    flexDirection: 'row',
    marginRight: 610,
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 30,
    height: 37,
  },
  feeText: {
    textAlign: 'right',
    fontSize: 26,
    color: '#132c32',
    fontFamily: 'PingFangSC-Semibold',
  },
  feeAmount: {
    fontFamily: 'PingFangSC-Regular',
    color: '#555559',
    fontSize: 26,
    marginLeft: 39,
    width: 164,
  },
  feeIcon: {
    marginLeft: 20,
  },
  receiveContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginRight: 355,
    height: 66,
    marginTop: 30,
  },
  receiveText: {
    textAlign: 'right',
    fontSize: 26,
    color: '#132c32',
    fontFamily: 'PingFangSC-Semibold',
  },
  receiveInputFrame: {
    borderBottomColor: '#555559',
    borderBottomWidth: 2,
    width: 386,
    justifyContent: 'flex-end',
  },
  receiveInputPlaceholder: {
    paddingLeft: 16,
    fontFamily: 'PingFangSC-Regular',
    fontSize: 16,
    marginBottom: 10,
  },
  receiveInput: {
    paddingLeft: 16,
    fontFamily: 'PingFangSC-Regular',
    fontSize: 23,
    marginBottom: 5,
    color: '#595959',
  },
  receiveNT: {
    fontFamily: 'PingFangSC-Regular',
    color: '#555559',
    fontSize: 26,
    marginRight: 25,
    marginLeft: 39,
  },
  bankContainer: {
    flexDirection: 'row',
    marginTop: 30,
    marginRight: 354,
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 37,
  },
  bankText: {
    textAlign: 'right',
    fontSize: 26,
    color: '#132c32',
    fontFamily: 'PingFangSC-Semibold',
    marginRight: 39,
  },
  bankInputFrame: {
    borderBottomColor: '#555559',
    borderBottomWidth: 2,
    width: 465,
    justifyContent: 'flex-end',
  },
  triangle: {
    width: 0,
    height: 0,
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderTopWidth: 12,
    borderRightWidth: 8.5,
    borderBottomWidth: 0,
    borderLeftWidth: 8.5,
    borderTopColor: '#555559',
    borderRightColor: 'transparent',
    borderBottomColor: 'transparent',
    borderLeftColor: 'transparent',
    marginBottom: 10,
    marginTop: 15,
    marginRight: 3,
  },
  confirmContainer: {
    width: 436,
    height: 68,
    marginTop: 87,
    marginLeft: 446,
    marginRight: 446,
  },
  confirmBackground: {
    width: '100%',
    height: '100%',
  },
  confirmText: {
    fontSize: 26,
    fontFamily: 'PingFangSC-Medium',
    color: '#fff',
    alignSelf: 'center',
    marginTop: 16,
  },
});
const RedeemScreen = React.memo(() => {
  const [redeemAmount, setRedeemAmount] = useState('');
  const [receiveAmount, setReceiveAmount] = useState('');
  const [bank, setBank] = useState('');
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [isLoading, setLoading] = useState(false);

  const handleRedeem = useCallback((amount: string) => {
    setRedeemAmount(Number(amount.replace(/\D/g, '')).toLocaleString('en'));
    setReceiveAmount((Number(amount.replace(/\D/g, '')) - 1000).toLocaleString('en'));
  }, []);

  const handleReceive = useCallback((amount: string) => {
    setRedeemAmount((Number(amount.replace(/\D/g, '')) + 1000).toLocaleString('en'));
    setReceiveAmount(Number(amount.replace(/\D/g, '')).toLocaleString('en'));
  }, []);

  const handleBank = useCallback((value: string) => {
    setBank(value);
  }, []);

  const handleClosePopup = useCallback(() => {
    setPopupVisible(false);
  }, []);

  const handlePress = useCallback(() => {
    async function fetch() {
      const docRef = doc(db, 'user', 'user');
      const docSnap = await getDoc(docRef);
      const docRefTwdc = doc(db, 'twdc', 'twdc');
      const docSnapTwdc = await getDoc(docRefTwdc);

      if (docSnap.exists()) {
        const { balance } = docSnap.data();
        if (balance < Number(redeemAmount.replace(/\D/g, ''))) {
          setLoading(false);
          setMessage('Exceed account limit!');
          return;
        }
        await updateDoc(docRef, {
          balance: balance - Number(redeemAmount.replace(/\D/g, '')),
        });
        // @ts-ignore
        const { trust } = docSnapTwdc.data();
        await updateDoc(docRefTwdc, {
          trust: trust - Number(redeemAmount.replace(/\D/g, '')),
        });
        console.log(`Redeem ${redeemAmount} TWDC to bank}`);
        const date = new Date();
        await setDoc(doc(db, 'activity', Date.now().toString()), {
          date: date.toLocaleString('tw', { year: 'numeric', month: '2-digit', day: '2-digit' }),
          description: `Redeem ${redeemAmount} TWDC from`,
          address: '0xdd2c45b296C218779783c9AAF9f876783c9AAF9f876',
          amount: `-${redeemAmount} TWDC`,
          status: 'Completed',
          timestamp: Date.now().toString(),
        });
        setLoading(false);
        setMessage('Success');
        setPopupVisible(true);
        setRedeemAmount('');
        setReceiveAmount('');
        setBank('');
      } else {
        // doc.data() will be undefined in this case
        console.log('No such document!');
      }
    }
    if (!(redeemAmount && receiveAmount && bank)) {
      setMessage('All fields must be filled!');
      setPopupVisible(true);
    } else if (Number(redeemAmount.replace(/\D/g, '')) < 100000) {
      setMessage('Minimum amount is 100,000 TWDC.');
      setPopupVisible(true);
    } else {
      setLoading(true);
      setPopupVisible(true);
      fetch();
    }
  }, [bank, receiveAmount, redeemAmount]);

  return (
    <View style={styles.container}>
      <View style={styles.titleContainer}>
        <Text style={styles.title}>
          Please enter the amount you want to redeem from your TWDC wallet and wire to your bank account.
        </Text>
      </View>
      <View style={styles.warningContainer}>
        <WarningIcon style={styles.warningIcon} />
        <Text style={styles.warningText}>The minimum redeemable amount is 100,000 TWDC.</Text>
      </View>
      <View style={styles.wireAmountContainer}>
        <Text style={styles.redeemAmountText}>Amount to Redeem:</Text>
        <Text style={styles.redeemAmountNT}>NT$</Text>
        <View style={styles.redeemAmountInputFrame}>
          <TextInput
            placeholder="Enter your amount to redeem"
            style={redeemAmount ? styles.redeemAmountInput : styles.redeemAmountInputPlaceholder}
            placeholderTextColor="#979797"
            value={redeemAmount}
            onChangeText={handleRedeem}
            keyboardType="numeric"
          />
        </View>
      </View>
      <View style={styles.feeContainer}>
        <Text style={styles.feeText}>Fee:</Text>
        <Text style={styles.feeAmount}>NT$ 1,000.00 </Text>
        <QuestionIcon style={styles.feeIcon} />
      </View>
      <View style={styles.receiveContainer}>
        <Text style={styles.receiveText}>
          Total Wire Amount
          <br />
          You Receive:
        </Text>
        <Text style={styles.receiveNT}>NT$</Text>
        <View style={styles.receiveInputFrame}>
          <TextInput
            style={receiveAmount ? styles.receiveInput : styles.receiveInputPlaceholder}
            placeholder="Amount you receive"
            placeholderTextColor="#979797"
            value={receiveAmount}
            onChangeText={handleReceive}
            keyboardType="numeric"
          />
        </View>
      </View>
      <View style={styles.bankContainer}>
        <Text style={styles.bankText}>Bank:</Text>
        <View style={styles.bankInputFrame}>
          <RNPickerSelect
            onValueChange={handleBank}
            value={bank}
            items={[
              { label: 'bank1', value: 'bank1' },
              { label: 'bank2', value: 'bank2' },
              { label: 'bank3', value: 'bank3' },
            ]}
            placeholder={{ label: 'Select your bank', value: '' }}
            Icon={() => {
              return <View style={styles.triangle} />;
            }}
            // @ts-ignore
            style={
              bank
                ? {
                    // @ts-ignore
                    inputWeb: {
                      borderWidth: 0,
                      height: 37,
                      color: '#595959',
                      paddingLeft: 16,
                      fontFamily: 'PingFangSC-Regular',
                      fontSize: 23,
                      marginLeft: 0,
                      // @ts-ignore
                      appearance: 'none',
                      textindent: 0,
                    },
                  }
                : {
                    // @ts-ignore
                    inputWeb: {
                      borderWidth: 0,
                      height: 37,
                      color: '#979797',
                      paddingLeft: 16,
                      fontFamily: 'PingFangSC-Regular',
                      fontSize: 16,
                      marginLeft: 0,
                      // @ts-ignore
                      appearance: 'none',
                      textindent: 0,
                    },
                  }
            }
          />
        </View>
      </View>
      <TouchableOpacity style={styles.confirmContainer} onPress={handlePress}>
        <LinearGradient
          colors={['#03ae9d', '#45459b']}
          start={{
            x: 0,
            y: 0,
          }}
          end={{
            x: 1,
            y: 1,
          }}
          style={styles.confirmBackground}
        >
          <Text style={styles.confirmText}>Confirm</Text>
        </LinearGradient>
      </TouchableOpacity>
      {isPopupVisible ? <Popup handleClosePopup={handleClosePopup} text={message} isLoading={isLoading} /> : <View />}
    </View>
  );
});

export default RedeemScreen;
